export default "__VITE_PUBLIC_ASSET__a2eb4200__"